import { RHFSelect } from '@talentmesh/ui/components/rhf-select';
import { JobDetailsFieldTypes } from '../JobDetailsStepUtils';
import workExperienceOptions from './WorkExperienceOptions';
import UIStrings from '@/Utils/UIStrings';

function WorkExperience() {
    const options = workExperienceOptions.map((o) => ({ id: String(o.id), name: o.name }));

    return (
        <RHFSelect
            label={`${UIStrings.WorkExperience}*`}
            name={JobDetailsFieldTypes.WorkExperience}
            options={options}
            fieldDataCy={JobDetailsFieldTypes.WorkExperience}
        />
    );
}

export default WorkExperience;
